import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/CartViewer';

function* getListProduct(action) {
    const endpoint = action?.payload?.language
        ? `/api/v1/cart/?language=${action?.payload?.language}`
        : '/api/v1/cart/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.getListProductReceived(response));
    } catch (error) {
        yield put(Actions.getListProductReceivedFailure(yield error));
    }
}

function* getListHistoryOrder(action) {
    const endpoint = '/api/v1/cart/transaction/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {
                    ...action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.getListHistoryOrderReceived(response));
    } catch (error) {
        yield put(Actions.getListHistoryOrderReceivedFailure(yield error));
    }
}

function* getDetailHistoryProduct(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/event/${action.payload.event_name}/grand_booth/order_content/${action.payload.transaction_id}/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload.event_name}/grand_booth/order_content/${action.payload.transaction_id}/`;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.getDetailHistoryProductReceived(response));
    } catch (error) {
        yield put(Actions.getDetailHistoryProductReceivedFailure(yield error));
    }
}

function* getUserProfile(action) {
    const endpoint = action?.payload?.language
        ? `/api/v1/user/profile/?language=${action.payload.language}`
        : '/api/v1/user/profile/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint,
                token: credential.data.token,
            },
        );
        yield put(Actions.getUserProfileReceived(response));
    } catch (error) {
        yield put(Actions.getUserProfileReceivedFailure(yield error));
    }
}

function* deleteProduct(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.delete, {
                endpoint: `/api/v1/cart/${action.payload.delete_id}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.deleteProductReceived(response));
    } catch (error) {
        yield put(Actions.deleteProductReceivedFailure(yield error));
    }
}

function* changeQuantityProduct(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.put, {
                endpoint: `/api/v1/cart/${action.payload.product_id}/`,
                token: credential.data.token,
                body: {
                    quantity: action.payload.quantity,
                },
            },
        );
        yield put(Actions.changeQuantityProductReceived(response));
    } catch (error) {
        yield put(Actions.changeQuantityProductReceivedFailure(yield error));
    }
}

function* orderProduct(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/cart/order_products/?language=${action.payload.language}`
        : '/api/v1/cart/order_products/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post, {
                endpoint,
                token: credential.data.token,
                body: action.payload?.language ? action.payload.data : action.payload,
            },
        );
        yield put(Actions.orderProductReceived(response));
    } catch (error) {
        yield put(Actions.orderProductReceivedFailure(yield error));
    }
}

function* getCountProduct() {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: '/api/v1/cart/product_number/',
                token: credential.data.token,
                body: {},
            },
        );
        yield put(Actions.getCountProductReceived(response));
    } catch (error) {
        yield put(Actions.getCountProductReceivedFailure(yield error));
    }
}

export default function* CartViewer() {
    yield all([
        takeLatest('GET_LIST_PRODUCT_REQUESTED', getListProduct),
        takeLatest('GET_LIST_HISTORY_ORDER_REQUESTED', getListHistoryOrder),
        takeLatest('GET_DETAIL_HISTORY_PRODUCT_REQUESTED', getDetailHistoryProduct),
        takeLatest('GET_USER_PROFILE_REQUESTED', getUserProfile),
        takeLatest('DELETE_PRODUCT_REQUESTED', deleteProduct),
        takeLatest('CHANGE_QUANTITY_PRODUCT_REQUESTED', changeQuantityProduct),
        takeLatest('ORDER_PRODUCT_REQUESTED', orderProduct),
        takeLatest('GET_COUNT_PRODUCT_REQUESTED', getCountProduct),
    ]);
}
